import styled from 'react-emotion'

const getColor = ({ theme, color }) => {
  const colors = {
    dark: '#000',
    light: '#fff',
    teal: '#000',
    danger: '#000',
    primary: '#09112B',
    overlay: '#000',
    warning: '#000',
    accent: '#000',
  }

  if (color) {
    return colors[color]
  } else {
    return colors['primary']
  }
}

// Accept values in pixels ( 960, 60, 32 )
export const ResponsiveTitle = styled.div(
  {
    transition: 'all .2s linear',
    margin: 0,
  },
  ({
    theme,
    color,
    breakpoint,
    max,
    min,
    weight,
    letterSpacing,
    uppercase,
    truncate,
    nowrap,
  }) => ({
    textShadow: `4px 4px #D1FF54, 8px 8px #4d4d4d`,
    color: getColor({ theme, color }),
    fontSize: `${max}px`,
    lineHeight: `${max}px`,
    fontWeight: weight ? weight : 700,
    letterSpacing: letterSpacing ? letterSpacing : 'inherit',
    textTransform: uppercase ? 'uppercase' : 'inherit',
    fontFamily: "'Montserrat Subrayada', sans-serif",
    whiteSpace: truncate || nowrap ? 'nowrap' : 'inherit',
    overflow: truncate ? 'hidden' : 'inherit',
    textOverflow: truncate ? 'ellipsis' : 'inherit',
    [`@media only screen and (max-width: ${breakpoint}px)`]: {
      fontSize: `${max / (breakpoint / 100)}vw`,
      lineHeight: `${max / (breakpoint / 100)}vw`,
    },
    [`@media only screen and (max-width: ${min /
      (max / (breakpoint / 100)) *
      100}px)`]: {
      fontSize: `${min}px`,
      lineHeight: `${min}px`,
    },
  })
)

export const ResponsiveH1 = ResponsiveTitle.withComponent('h1')
export const ResponsiveH2 = ResponsiveTitle.withComponent('h2')
export const ResponsiveH3 = ResponsiveTitle.withComponent('h3')
export const ResponsiveH4 = ResponsiveTitle.withComponent('h4')
export const ResponsiveH5 = ResponsiveTitle.withComponent('h5')
export const ResponsiveH6 = ResponsiveTitle.withComponent('h6')

// Accept values in pixels ( 960, 60, 32 )
export const UppercaseTitle = styled.div(
  {
    fontWeight: 600,
    letterSpacing: '1px',
    transition: 'all .2s linear',
    textTransform: 'uppercase',
    margin: 0,
  },
  ({ theme, color, breakpoint, max, min }) => ({
    color: getColor({ theme, color }),
    fontSize: `${max}px`,
    lineHeight: `${max}px`,
    fontFamily: "'Montserrat Subrayada', sans-serif",
    [`@media only screen and (max-width: ${breakpoint}px)`]: {
      fontSize: `${max / (breakpoint / 100)}vw`,
      lineHeight: `${max / (breakpoint / 100)}vw`,
    },
    [`@media only screen and (max-width: ${min /
      (max / (breakpoint / 100)) *
      100}px)`]: {
      fontSize: `${min}px`,
      lineHeight: `${min}px`,
    },
  })
)

export const UppercaseH1 = UppercaseTitle.withComponent('h1')
export const UppercaseH2 = UppercaseTitle.withComponent('h2')
export const UppercaseH3 = UppercaseTitle.withComponent('h3')
export const UppercaseH4 = UppercaseTitle.withComponent('h4')
export const UppercaseH5 = UppercaseTitle.withComponent('h5')
export const UppercaseH6 = UppercaseTitle.withComponent('h6')



// WEBPACK FOOTER //
// ./src/components/Title/styles/StyledResponsiveTitle.js